import axios from 'axios';

let Stat : any = {};

Stat.getResInfo = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/stats/reservation/${id}`)
}

export default Stat;